import { HttpErrorResponse } from "@angular/common/http";
import { outdent } from "outdent";

export class ApiError extends Error {
  private constructor(
    public readonly status: number,
    public override readonly message: string,
    public readonly errors?: string,
    public readonly url?: string,
  ) {
    super(outdent`
      API Error
      Status: ${status}
      Message: ${message ?? "<None>"}
      Request: ${url ?? "<None>"}
      Details:
      ${errors ?? "<None>"}
    `);

    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "ApiError";
  }

  public static create(args: HttpErrorResponse | ApiErrorArguments): ApiError {
    const { status, message, errors, url } = processArguments(args);

    return new ApiError(status, message, errors, url);
  }

  public override toString(): string {
    return this.stack ?? this.message;
  }
}

interface ClientErrorModel {
  readonly statusCode: number;
  readonly errors: string[] | null;
  readonly message: string;
}

interface ApiErrorArguments {
  readonly status: number;
  readonly errors?: string;
  readonly message: string;
  readonly url?: string;
}

function processArguments(
  args: HttpErrorResponse | ApiErrorArguments,
): ApiErrorArguments {
  if (args instanceof HttpErrorResponse) {
    const { url, status } = args;
    const error = args.error as ClientErrorModel;
    return {
      status,
      message: error.message,
      errors: error.errors?.join(","),
      url: url ?? undefined,
    };
  } else {
    return args;
  }
}
